































































































import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import store from "@/store";
import { getModule } from "vuex-module-decorators";
import DataQualityModule from "@/store/clients/DataQuality.module";
import dataQualityClient from "@/Scripts/clients/data-quality-client.js";

const DataQuality = getModule(DataQualityModule, store);

@Component({
  components: {},
})
export default class OutlierFeaturesModal extends Vue {
  @PropSync("value", { required: true }) isModalActive!: boolean;
  @Prop({ required: true, type: Number }) companyId!: number;

  searchQuery = "";
  availableFeatures: any[] = [];
  selectedFeatureNames: string[] = [];
  isLoading = false;
  isSaving = false;

  get filteredFeatures(): any[] {
    const query = this.searchQuery?.toLowerCase() || "";
    if (!query) return this.availableFeatures;
    return this.availableFeatures.filter(f => f.name.toLowerCase().includes(query));
  }

  @Watch("isModalActive")
  async onModalActiveChanged(isActive: boolean): Promise<void> {
    if (isActive) {
      await this.loadFeatures();
    } else {
      this.searchQuery = "";
    }
  }

  async loadFeatures(): Promise<void> {
    this.isLoading = true;
    try {
      const [companyVesselFeatures, companyFeatures] = await Promise.all([
        dataQualityClient.getCompanyFeatures({ companyId: this.companyId }),
        dataQualityClient.getOutlierFeatures({ companyId: this.companyId }),
      ]);
      this.availableFeatures = (companyVesselFeatures as any[]).filter(
        (f: any) => !f.name.includes("[Noon]")
      );
      this.selectedFeatureNames = (companyFeatures as any[])
        .filter((f: any) => !f.name.includes("[Noon]"))
        .map((f: any) => f.name);
    } finally {
      this.isLoading = false;
    }
  }

  async save(): Promise<void> {
    this.isSaving = true;
    try {
      await DataQuality.saveOutlierFeatures({
        companyId: this.companyId,
        featureNames: this.selectedFeatureNames,
      });
      this.$emit("saved");
      this.isModalActive = false;
    } finally {
      this.isSaving = false;
    }
  }

  close(): void {
    this.isModalActive = false;
  }
}
